import React, { useContext } from 'react';
import { AppContext } from '../contexts/context';
import Fab from '@mui/material/Fab';
import Zoom from '@mui/material/Zoom';
import ContactlessIcon from '@mui/icons-material/Contactless';

const DataExchangeFab = ({ onClick }) => {
  const [ state ] = useContext(AppContext);
  const enabled = state.nfcAvailable === true && state.nfcPermission === 'granted';

  return (
    <Zoom in={true} style={{ transitionDelay: '500ms' }}>
      <Fab
        disabled={!enabled}
        variant="extended"
        color="primary"
        aria-label="scan"
        onClick={enabled ? onClick : undefined}
        sx={{ position: "fixed", minWidth: 80, height: 56, bottom: 16, right: 16 }}
      >
        <ContactlessIcon sx={{ mr: 1 }} />
        Data Exchange
      </Fab>
    </Zoom>
  )
}

export default DataExchangeFab;
